import { Component, OnInit } from '@angular/core';
import { EventNavigationCategory, NavData, CategoryLinks } from '../../models/eventNavigation.model';
import { Events, NavController, NavParams, ViewController, Tab, PopoverController } from 'ionic-angular';
import { EventNavigationProvider } from '../../providers/event-navigation/event-navigation';
import { CurrentEventProvider } from '../../providers/current-event/current-event';

/**
 * Generated class for the EventNavigationTabsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'event-navigation-tabs',
    templateUrl: 'event-navigation-tabs.html'
})
export class EventNavigationTabsComponent implements OnInit {

    navigation: CategoryLinks[] = [];
    navigationDynamic: CategoryLinks[] = [];
    features: any[];

    constructor(
        public events: Events,
        public navCtrl: NavController,
        public navParams: NavParams,
        private eventNavigationProvider: EventNavigationProvider,
        public viewCtrl: ViewController,
        public popoverCtrl: PopoverController,
        public currentEventProvider: CurrentEventProvider
    ) { }

    ngOnInit() {
        this.features = this.currentEventProvider.selectedEvent && this.currentEventProvider.selectedEvent.eventFeatures;
        const hasAgenda = this.features.includes('AGENDA');
        const isCommunity = this.currentEventProvider.selectedEvent && this.currentEventProvider.selectedEvent.eventType === 'COMMUNITY' ? true : false;
        this.loadNavigation(isCommunity, hasAgenda);
        this.loadNavigationDynamic(isCommunity);
    }

    loadNavigation(isCommunity?: boolean, hasAgenda?: boolean): void {
        this.navigation = this.eventNavigationProvider.loadNavigationTabs(isCommunity, hasAgenda);
    }

    loadNavigationDynamic(isCommunity?: boolean) {
        let response = this.eventNavigationProvider.loadNavigationTabsDynamic(isCommunity);
        response.map((item) => {
            if (this.features) {
                if (this.features.includes(item.linkSegment)) {
                    item.active = true;
                }
            }
        });
        this.navigationDynamic = response;

    }

    presentPopover(event) {
        const popover = this.popoverCtrl.create('TabsPopoverPage', {
            navigation: this.navigationDynamic
        }, {
                cssClass: 'navigation-popover',
            });
        popover.onDidDismiss((data?: CategoryLinks) => {
            console.log('Ovo je data =>', data);
            if (data) {
                if (typeof data === 'object') {
                    const nav = new NavData();
                    nav.page = data.linkPage;
                    nav.segment = data.linkSegment;
                    this.navigate(nav);
                }
            }
        });
        popover.present({
            ev: event,
        });
    }

    navigate(navData: NavData): void {
        this.events.publish('segment', navData.segment);
        this.currentEventProvider.setCurrentSegment(navData.segment);
        this.navCtrl.parent.select(navData.page);
        console.log("Tab clicked: " + navData.segment);
        this.currentEventProvider.clickTab(navData);
    }

    get selectedTab() {
        let index = (<Tab>this.navCtrl).index;
        return index == undefined ? 0 : (<Tab>this.navCtrl).index.toString();
    }

    showExhibitors() {
        return this.features.includes('EXHIBITORS');
    }

}



// WEBPACK FOOTER //
// ./src/components/event-navigation-tabs/event-navigation-tabs.ts